import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useUserStore } from '../store/useUserStore';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../pages/login/LoginPage.vue'),
    meta: { title: '工程北米 · 有机溯源登录' },
  },
  {
    path: '/scan',
    name: 'Scan',
    component: () => import('../pages/scan/ScanPage.vue'),
    meta: { title: '扫码防伪溯源' },
  },
  {
    path: '/trace',
    name: 'TraceOverview',
    component: () => import('../pages/trace/TraceOverviewPage.vue'),
    meta: { title: '溯源总览 - 工程北米有机农产品' },
  },
  {
    path: '/base-map',
    name: 'BaseMap',
    component: () => import('../pages/base-map/BaseMapPage.vue'),
    meta: { title: '基地电子地图' },
  },
  {
    path: '/land-detail',
    name: 'LandDetail',
    component: () => import('../pages/land-detail/LandDetailPage.vue'),
    meta: { title: '地块全量档案' },
  },
  {
    path: '/farming',
    name: 'FarmingDetail',
    component: () => import('../pages/farming/FarmingDetailPage.vue'),
    meta: { title: '种植农事追溯' },
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    component: () => import('../pages/enterprise/EnterprisePage.vue'),
    meta: { title: '企业资质与品牌' },
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('../pages/tools/ToolsPage.vue'),
    meta: { title: '辅助工具与分享' },
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../pages/report/ReportPage.vue'),
    meta: { title: '有机品质溯源证书' },
  },
  {
    path: '/appointment',
    name: 'Appointment',
    component: () => import('../pages/appointment/AppointmentPage.vue'),
    meta: { title: '基地参观预约' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, _, next) => {
  if (to.meta?.title) {
    document.title = `${to.meta.title}`;
  }

  // 1. 拦截从微信扫码等渠道传入的溯源码参数 code 并持久暂存
  const codeParam = to.query.code as string;
  if (codeParam) {
    sessionStorage.setItem('pending_trace_code', codeParam);
  }

  const userStore = useUserStore();

  // 2. 如果访问根路径 / 且带有 code 参数，直接定向到溯源详情页
  if (to.path === '/' && (codeParam || sessionStorage.getItem('pending_trace_code'))) {
    const targetCode = codeParam || sessionStorage.getItem('pending_trace_code');
    return next({ path: '/trace', query: { code: targetCode } });
  }

  // 3. 扫码直达业务场景：若访问业务详情页且未登录，自动免密静默登录（零弹窗阻断）
  if (!userStore.token && to.path !== '/login') {
    try {
      await userStore.silentLogin();
    } catch (err) {
      console.warn('静默免密登录异常:', err);
    }
  }

  next();
});

export default router;
